import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MessagesComponent } from '../../components/messages/messages.component';
import { NotificationsService } from '../../services/notifications.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit {
  constructor(
    public modalController: ModalController,
    public notificationsService: NotificationsService
  ) {
  }

  ngOnInit() { }


  async presentMessagesModal() {
    const modal = await this.modalController.create({
      component: MessagesComponent,
      cssClass: 'messages-modal',
      breakpoints: [0.25, 0.5, 0.75, 1],
      initialBreakpoint: 0.75
    });
    return await modal.present();
  }


}
